const moment = require("moment");

module.exports = function (getRestrictions, value) {
  var restrictions = getRestrictions('date');
  var errorMessages = [];

  if (restrictions.length) {
    for (var i in restrictions) {
      if (!isValidFormat(restrictions[i])) {
        errorMessages.push({ message: 'date_format', params: getParameters(restrictions[i]) });
      }

      if (restrictions[i].daterange && !isInRange(restrictions[i])) {
        errorMessages.push({ message: 'date_range', params: getParameters(restrictions[i]) });
      }
    }

    if (errorMessages.length) {
      throw errorMessages;
    }
  }

  return value;

  function getParameters (r) {
    var format = r.dateformat;
    var base = r.daterange
      ? {
        value: value,
        end: moment(r.daterange.end, 'MM/DD/YY').format(format),
        start: moment(r.daterange.start, 'MM/DD/YY').format(format),
        example: moment(r.daterange.start, 'MM/DD/YY').format(format)
      }
      : { value: value, example: moment().format(format) };

    return _.extend(base, r);
  }

  function isValidFormat (restriction) {
    return moment(value.replace(/\s/g, ' '), restriction.dateformat, true).isValid();
  }

  function isInRange (restriction) {
    var start = moment(restriction.daterange.start, 'MM/DD/YY');
    var end = moment(restriction.daterange.end, 'MM/DD/YY');
    var v = moment(value.replace(/\s/g, ' '), restriction.dateformat, true);

    return v >= start && v <= end;
  }
};
